import styles from './index.module.scss';
import PriceBox from "@/app/_components/Shared/PriceBox";

export default function Prices({
     data
   }) {
    return (
        <div className={styles.prices}>
            {data.map((service, index) => (
                <PriceBox
                    key={index}
                    type={service.type}
                    title={service.title}
                    description={service.description}
                    onClick={service.onClick}
                    buttonText={service.button_text}
                />
            ))}
        </div>
    );
}